import connectLogo from '../../../../../images/cc/connectwise_manage_logo.png';
import connectWiseManageIcon from '../../../../../images/cc/cw-manage-24x24.png';

import { createDefaultService } from '../../../services';
import CredentialsView from './CredentialsView';

export default {
    name: 'connectwisemanage',
    label: 'ConnectWise Manage',
    agreementLabel: 'Agreement',
    enabled: true,
    visible: true,
    guide_url: 'connectwise_manage_setup_guide_url',
    logo: connectLogo,
    icon: connectWiseManageIcon,
    components: {
        CredentialsView,
    },
    serviceProvider: createDefaultService('connectwisemanage'),
    methods: {
        isInstalled(service) {
            return !!(service && service.extra && service.extra.host);
        },
    },
};
